import { NgClass } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [NgClass, TranslatePipe, MatTooltipModule],
  selector: 'iot-platform-ui-event-severity-display',
  templateUrl: './event-severity-display.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./event-severity-display.component.scss']
})
export class EventSeverityDisplayComponent {
  severity = input<string>();
  tooltip = input<string | null>();
}
